/* HASLOM - tira nasal 3D interactiva (capas) */
(function(){
  var SELF = document.currentScript && document.currentScript.src;
  function boot(el, THREE){
    var D = JSON.parse(el.querySelector('script[type="application/json"]').textContent);
    var BLK = D.variant === 'black';
    var wrap = el.querySelector('.h3d__stage');
    var W = wrap.clientWidth, H = wrap.clientHeight;
    var renderer = new THREE.WebGLRenderer({antialias:true, alpha:true});
    renderer.setPixelRatio(Math.min(window.devicePixelRatio||1, 2));
    renderer.setSize(W, H);
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    wrap.insertBefore(renderer.domElement, wrap.firstChild);
    var scene = new THREE.Scene();
    var cam = new THREE.PerspectiveCamera(30, W/H, 1, 2000);

    // ---- curved geometry from prebuilt meshes
    var M = window.__H3D_MESH[D.variant];
    var R = 55;
    function bp(x, y, z, out){ var a = x/R, r = R+z; out.push(r*Math.sin(a), r*Math.cos(a)-R, -y); }
    function geo(V, F, loops, zt, zb){
      var n = V.length/2, pos = [], uv = [], idx = [], i;
      for (i = 0; i < n; i++){ bp(V[2*i]/10, V[2*i+1]/10, zt(i), pos); uv.push((V[2*i]/10+34)/68, (V[2*i+1]/10+11)/22); }
      for (i = 0; i < n; i++){ bp(V[2*i]/10, V[2*i+1]/10, zb(i), pos); uv.push((V[2*i]/10+34)/68, (V[2*i+1]/10+11)/22); }
      for (i = 0; i < F.length; i += 3){ idx.push(F[i], F[i+1], F[i+2]); idx.push(n+F[i], n+F[i+2], n+F[i+1]); }
      var g = new THREE.BufferGeometry();
      g.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3)); g.setAttribute('uv', new THREE.Float32BufferAttribute(uv, 2));
      g.setIndex(idx); g.computeVertexNormals();
      var sp = [], si = [], k = 0;
      loops.forEach(function(L){ var s0 = L[0], c = L[1], j;
        for (j = 0; j < c; j++){ var q = s0+j; bp(V[2*q]/10, V[2*q+1]/10, zt(q), sp); bp(V[2*q]/10, V[2*q+1]/10, zb(q), sp); }
        for (j = 0; j < c; j++){ var jn = (j+1)%c, A = k+2*j, B = A+1, C = k+2*jn, Dd = C+1; si.push(A, B, C, C, B, Dd); }
        k += 2*c; });
      var gs = new THREE.BufferGeometry(); gs.setAttribute('position', new THREE.Float32BufferAttribute(sp, 3)); gs.setIndex(si); gs.computeVertexNormals();
      return [g, gs];
    }
    function canvasTex(draw){
      var c = document.createElement('canvas'); c.width = 1024; c.height = 512; var x = c.getContext('2d'); draw(x, c);
      var t = new THREE.CanvasTexture(c); t.colorSpace = THREE.SRGBColorSpace; return t;
    }
    var fabricTex = canvasTex(function(x, c){
      x.fillStyle = BLK ? '#202227' : '#d9ad8a'; x.fillRect(0, 0, c.width, c.height);
      var id = x.getImageData(0, 0, c.width, c.height), d = id.data;
      for (var i = 0; i < d.length; i += 4){ var n = (Math.random()-.5)*(BLK?10:14); d[i]+=n; d[i+1]+=n; d[i+2]+=n; }
      x.putImageData(id, 0, 0);
    });
    var linerTex = canvasTex(function(x, c){
      x.fillStyle = '#f1f2f4'; x.fillRect(0, 0, c.width, c.height);
      x.fillStyle = 'rgba(0,0,0,.18)'; x.fillRect(c.width/2-2, 0, 3, c.height);
    });
    var DS = THREE.DoubleSide;
    var mats = {
      fabric: new THREE.MeshPhysicalMaterial({map:fabricTex, roughness:BLK?.7:.85, sheen:.6, sheenRoughness:.7, sheenColor:new THREE.Color(BLK?0x5a606b:0xffe2cc), side:DS}),
      fabricEdge: new THREE.MeshStandardMaterial({color:BLK?0x16171b:0xc29a7b, roughness:.9, side:DS}),
      bands:  new THREE.MeshPhysicalMaterial({color:BLK?0x2f6bff:0x5b95ff, roughness:.25, clearcoat:.8, clearcoatRoughness:.2, side:DS}),
      adh:    new THREE.MeshPhysicalMaterial({color:BLK?0x9ea4ae:0xf0e1d2, roughness:.3, clearcoat:1, clearcoatRoughness:.12, side:DS}),
      liner:  new THREE.MeshPhysicalMaterial({map:linerTex, roughness:.45, side:DS})
    };
    var root = new THREE.Group(); scene.add(root);
    var layers = [];
    function addLayer(parts, mat, edgeMat, gap){
      var g = new THREE.Group(); g.add(new THREE.Mesh(parts[0], mat)); g.add(new THREE.Mesh(parts[1], edgeMat||mat)); root.add(g);
      layers.push({g:g, gap:gap}); return g;
    }
    var OL = [[0, M.nb]];
    var bh = BLK ? .6 : .35, br = M.bw/2;
    var bandsCY = []; M.bl.forEach(function(L){ var s=0; for (var j=0;j<L[1];j++) s += M.bv[2*(L[0]+j)+1]/10; bandsCY.push([L[0], L[0]+L[1], s/L[1]]); });
    function bandZ(i){ var y = M.bv[2*i+1]/10, cy = 0; for (var k=0;k<bandsCY.length;k++){ if (i>=bandsCY[k][0] && i<bandsCY[k][1]) { cy = bandsCY[k][2]; break; } } var d = Math.min(1, Math.abs(y-cy)/br); return .05 + bh*Math.sqrt(Math.max(0, 1-d*d)); }
    addLayer(geo(M.v, M.f, OL, function(){return .5;}, function(){return 0;}), mats.fabric, mats.fabricEdge, 0);
    addLayer(geo(M.bv, M.bf, M.bl, bandZ, function(){return 0;}), mats.bands, null, 1);
    addLayer(geo(M.v, M.f, OL, function(){return .2;}, function(){return 0;}), mats.adh, null, 2);
    addLayer(geo(M.v, M.f, OL, function(){return .15;}, function(){return 0;}), mats.liner, null, 3);
    var ys = BLK ? [-4.5, -1.5, 1.5, 4.5] : [-2.6, 0, 2.6];
    var baseY = [0.85, 0.6, 0.18, 0.0];

    scene.add(new THREE.HemisphereLight(0xffffff, 0xa9b3c6, BLK?1.5:1.1));
    var key = new THREE.DirectionalLight(0xffffff, BLK?2.4:2.1); key.position.set(-40, 90, 50); scene.add(key);
    var rim = new THREE.DirectionalLight(0xdfe8ff, BLK?1.4:.7); rim.position.set(60, 30, -70); scene.add(rim);
    var fill = new THREE.DirectionalLight(0xffffff, .45); fill.position.set(30, 20, 90); scene.add(fill);

    // soft floor shadow
    var sc = document.createElement('canvas'); sc.width = sc.height = 256; var sx = sc.getContext('2d');
    var gr = sx.createRadialGradient(128, 128, 10, 128, 128, 128); gr.addColorStop(0, 'rgba(1,14,41,.22)'); gr.addColorStop(1, 'rgba(1,14,41,0)');
    sx.fillStyle = gr; sx.fillRect(0, 0, 256, 256);
    var shadow = new THREE.Mesh(new THREE.PlaneGeometry(90, 34), new THREE.MeshBasicMaterial({map:new THREE.CanvasTexture(sc), transparent:true, depthWrite:false}));
    shadow.rotation.x = -Math.PI/2; scene.add(shadow);

    // ---- labels
    var labelEls = Array.prototype.slice.call(el.querySelectorAll('.h3d__lab'));
    var anchors = [[-21, -5, .5], [-17, ys[0], .4], [-13, -5, .2], [-9, -5, .15]].map(function(a){ var o = []; bp(a[0], a[1], a[2], o); return new THREE.Vector3(o[0], o[1], o[2]); });

    // ---- interaction
    var yaw = -0.35, pitch = 0.55, tYaw = yaw, tPitch = pitch, dragging = false, lx = 0, ly = 0, idle = 0;
    var explode = 0, target = 1;
    var cv = renderer.domElement;
    cv.style.touchAction = 'pan-y';
    cv.addEventListener('pointerdown', function(e){ dragging = true; lx = e.clientX; ly = e.clientY; idle = 0; cv.setPointerCapture(e.pointerId); });
    cv.addEventListener('pointermove', function(e){ if(!dragging) return; tYaw += (e.clientX-lx)*0.008; tPitch = Math.max(0.05, Math.min(1.35, tPitch+(e.clientY-ly)*0.006)); lx = e.clientX; ly = e.clientY; idle = 0; });
    ['pointerup','pointercancel','pointerleave'].forEach(function(ev){ cv.addEventListener(ev, function(){ dragging = false; }); });
    var btn = el.querySelector('.h3d__btn');
    function setBtn(){ btn.textContent = target ? btn.dataset.join : btn.dataset.split; }
    btn.addEventListener('click', function(){ target = target ? 0 : 1; setBtn(); });
    setBtn();

    var visible = true;
    if ('IntersectionObserver' in window){ new IntersectionObserver(function(es){ visible = es[0].isIntersecting; if(visible) loop(); }, {threshold:0.05}).observe(el); }
    window.addEventListener('resize', function(){ W = wrap.clientWidth; H = wrap.clientHeight; renderer.setSize(W, H); cam.aspect = W/H; cam.updateProjectionMatrix(); });

    var v = new THREE.Vector3(), running = false;
    function frame(){
      idle++;
      if (!dragging && idle > 120) tYaw += 0.0025;
      yaw += (tYaw-yaw)*0.12; pitch += (tPitch-pitch)*0.12;
      explode += (target-explode)*0.08;
      var gapY = 14*explode, gapX = 5*explode;
      layers.forEach(function(L, i){ L.g.position.set(gapX*i*0.5, baseY[i]-gapY*L.gap + 21*explode, gapX*i*0.4); });
      shadow.position.y = -21*explode - 10.5;
      var dist = 112 + 34*explode;
      cam.position.set(Math.sin(yaw)*Math.cos(pitch)*dist, Math.sin(pitch)*dist, Math.cos(yaw)*Math.cos(pitch)*dist);
      var lt=new THREE.Vector3(-13*explode,0,0).applyAxisAngle(new THREE.Vector3(0,1,0),yaw); cam.lookAt(lt.x, -4, lt.z); cam.aspect = W/H; cam.updateProjectionMatrix();
      renderer.render(scene, cam);
      var show = explode > 0.6;
      labelEls.forEach(function(lab, i){
        v.copy(anchors[i]); layers[i].g.localToWorld(v); v.project(cam);
        var x = (v.x+1)/2*W, y = (1-v.y)/2*H;
        lab.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
        lab.style.opacity = show ? Math.min(1, (explode-0.6)*2.5) : 0;
        lab.classList.toggle('is-left', x > W*0.5 === false);
      });
      if (visible) requestAnimationFrame(frame); else running = false;
    }
    function loop(){ if (!running){ running = true; requestAnimationFrame(frame); } }
    loop();
    el.classList.add('is-ready');
  }
  function start(){
    var els = document.querySelectorAll('.h3d:not(.is-init)');
    if (!els.length) return;
    els.forEach(function(e){ e.classList.add('is-init'); });
    var url = els[0].getAttribute('data-three');
    function go(){ var T = window.__H3D_THREE; els.forEach(function(e){ try { boot(e, T); } catch(err){ console.error(err); e.classList.add('is-failed'); } }); }
    var need = 2, fired = false;
    function ready(){ if (--need === 0) go(); }
    function fail(){ if (fired) return; fired = true; els.forEach(function(e){ e.classList.add('is-failed'); }); }
    if (window.__H3D_MESH) ready(); else { var ms = document.createElement('script'); ms.src = (SELF||'').replace('haslom-strip3d.js', 'haslom-strip3d-mesh.js'); ms.onload = ready; ms.onerror = fail; document.head.appendChild(ms); }
    if (window.__H3D_THREE) { ready(); return; }
    window.addEventListener('h3d-three', ready, {once:true});
    window.addEventListener('h3d-three-fail', fail, {once:true});
    var s = document.createElement('script'); s.type = 'module';
    s.textContent = "import * as T from '" + url.replace(/'/g, '') + "'; window.__H3D_THREE = T; window.dispatchEvent(new Event('h3d-three'));";
    s.onerror = function(){ window.dispatchEvent(new Event('h3d-three-fail')); };
    document.head.appendChild(s);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
